import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&utm_source=FB&country=US&area=female&exp=web_fasting_fem_ai_coach_meal_plan~1
			funnel: {
				id: 'ob-female-coach-meal-plan',
				locale: ['en'],
			},
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_fasting_fem_ai_coach_meal_plan'
					),
			},
		},
	},
]

export default config
